import React, { useState } from 'react';
import { Trophy } from 'lucide-react';
import { Card } from '../ui/card';
import { useRepStats, PeriodToggle } from './useRepStats';

const MEDALS = ['bg-amber-400 text-white', 'bg-slate-400 text-white', 'bg-orange-700 text-white'];

export const RepLeaderboard = ({ token }) => {
  const [period, setPeriod] = useState('month');
  const reps = useRepStats(token, period)?.reps || [];

  return (
    <Card className="p-6 bg-white border-slate-200 mb-6" data-testid="rep-leaderboard">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-amber-100 flex items-center justify-center">
            <Trophy className="w-5 h-5 text-amber-600" />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-slate-900">Rep Leaderboard</h2>
            <p className="text-sm text-slate-500">Ranked by paid customers, then signups (admin only)</p>
          </div>
        </div>
        <PeriodToggle period={period} setPeriod={setPeriod} />
      </div>
      {reps.length === 0 ? (
        <p className="text-sm text-slate-500">No sales reps yet.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-slate-200 text-slate-500">
                <th className="text-left py-2 px-3 font-medium">#</th>
                <th className="text-left py-2 px-3 font-medium">Rep</th>
                <th className="text-right py-2 px-3 font-medium">Brains</th>
                <th className="text-right py-2 px-3 font-medium">Links Sent</th>
                <th className="text-right py-2 px-3 font-medium">Signups</th>
                <th className="text-right py-2 px-3 font-medium">Paid</th>
              </tr>
            </thead>
            <tbody>
              {reps.map((r, i) => (
                <tr key={r.id} className="border-b border-slate-100" data-testid={`leaderboard-row-${r.id}`}>
                  <td className="py-2 px-3">
                    <span className={`inline-flex w-6 h-6 rounded-full items-center justify-center text-xs font-bold ${(r.paid + r.signups > 0 && MEDALS[i]) || 'bg-slate-100 text-slate-600'}`}>{i + 1}</span>
                  </td>
                  <td className="py-2 px-3 text-slate-900 font-medium">{r.name}</td>
                  <td className="py-2 px-3 text-right text-slate-600">{r.brains_saved}</td>
                  <td className="py-2 px-3 text-right text-slate-600">{r.invites_sent}</td>
                  <td className="py-2 px-3 text-right text-blue-600 font-medium">{r.signups}</td>
                  <td className="py-2 px-3 text-right text-green-600 font-bold">{r.paid}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Card>
  );
};
